import { Icon } from "@chakra-ui/react"

const ForwardArrowIcon = () => {
  return (
    <Icon viewBox='0 0 16 16' fill='none'>
      <path
        d='M10 11.3333L13.3333 8L10 4.66666'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.66675 12V10.6667C2.66675 9.95942 2.9477 9.28115 3.4478 8.78105C3.94789 8.28095 4.62617 8 5.33341 8H13.3334'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  )
}
export default ForwardArrowIcon
